import React from "react";
import styled from "@emotion/styled";
import { Box } from '@mui/material';
import ActivityLog from "./ActivityLog";

const Container = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(2),
}));

const AccountTabActivity = ({ accountId, accountSlug }) => (
    <Container>
        <ActivityLog
            objectId={accountId}
            objectType="account"
            fallbackAccountSlug={accountSlug}
        />
    </Container>
);

export default AccountTabActivity;
